/* Rotas dos serviços existentes na api */

// const BASE_ROUTE = `${process.env.PUBLIC_URL}/`;

/*
	ROTAS DOS MODULOS DO ALERTAS
*/
export const ALERTAS_ROUTE = {
	FIND_BY_ID: "alerta/buscar/{alertaId}",
	CREATE: "alerta/cadastrar",
	CHANGE_STATUS: "alerta/alterarStatus",
	FIND_BY_FILTER: "alerta/filtro",
	EMIT_ALERTA: "alerta/emitir",
	ALERTA_CSV: "exportaAlertaCsv",
	FIND_ALL_STATUS: "alerta/findAllStatus"
};

export const DADOS_PARAM_ROUTE = {
	SAVE_DADOS_PARAMETRIZADOS: "dadosparametrizados"
};

export const GEO_ROUTE = {
	SAVE_GEO: "geo",
	GET_INTERSECTION: "geo/intersection"
};

export const MONITORAMENTO_ROUTE = {
	FIND_BY_ID: "monitoramento/{id}",
	CREATE: "monitoramento",
	EXPORT_PDF: "monitoramento/{id}/exportar/pdf/"
};

export const EMISSAO_ROUTE = {
	FIND_BY_ID: "emissao/{id}",
	CREATE: "emissao",
	CREPDECS: "emissao/crepdecs"
};

/*
	ROTAS DOS MODULO PRESTACAO DE DONTAS
*/
export const PRESTACAO_CONTA_ROUTE = {
	EXPORT_PDF: "prestacaoContas/{id}/exportar/pdf/"
};

/*
	ROTAS COMUNS
*/
export const COMUM_ROUTE = {
	FIND_ALL_ORGAOS: "dadosparametrizados/orgaos",
	FIND_ALL_CATEGORIAS: "dadosparametrizados/categorias",
	FIND_ALL_SEVERIDADES: "severidade",
	FIND_ALL_URGENCIAS: "dadosparametrizados/urgencia",
	FIND_ALL_CONFIANCAS: "dadosparametrizados/confianca",
	FIND_ALL_ORIGENS: "monitoramento/origens",
	FIND_ALL_RESPONSAVEIS: "monitoramento/responsaveis"
};

export const UPLOAD_ROUTE = {
	UPLOAD_ARQUIVO: "upload"
};

export const DEVELOPMENT_LOGIN = "http://localhost:9100/login";

/*
	ROTAS ITEM DOACAO
*/
export const ITEM_DOACAO = {
	FIND_FILTRO: "itemDoacao/filtro",
	FIND_ID_FILTRO: "itemDoacao/{id}/filtro",
	SALVAR: "itemDoacao/salvar",
	FIND_ALL_ITEM_DOACAO: "tipoItemDoacao/findAll",
	FIND_ALL_UNIDADE_MEDIDA: "unidadeMedida/findAll",
	ENTRADA: "itemDoacao/entrada",
	SAIDA: "itemDoacao/saida",
	HISTORICO_EDITAR: "itemDoacao/historico/editar",
	FIND_ALL_HISTORICO: "itemDoacao/buscarHistorico/{id}",
	HISTORICO_CANCELAR: "itemDoacao/historico/cancelar"
};

/*
	ROTAS ENTIDADE
*/
export const ENTIDADE = {
	FIND_ALL_FILTRO: "entidade",
	FIND_ID_FILTRO: "entidade/{id}",
	FIND_FILTRO: "entidade/filtro",
	SALVAR: "entidade/salvar",
	CANCELAR: "entidade/cancelar",
	FIND_ALL_OFICIOS: "entidade/{id}/oficios"
};

/*
	ROTAS OFICIO
*/
export const OFICIO = {
	FIND_ALL_FILTRO: "oficio/filtro",
	FIND_ALL: "oficio",
	FIND_ID: "oficio/{id}",
	SALVAR: "oficio/salvar",
	CANCELAR: "oficio/cancelar",
	EDITAR: "oficio/editar",
	FIND_ALL_STATUS: "oficio/status/findAll",
	ATIVOS: "oficio/ativos"
};

/*
	ROTA CREPDEC
*/
export const CREPDEC = {
	FIND_ALL: "crepdec/findAll"
};

/*
	ROTAS OFICIO
*/
export const DACA = {
	FIND_FILTRO: "daca/filtro",
	FIND_ALL: "daca",
	FIND_ID: "daca/findById/{id}",
	HISTORICO_DEVOLUCAO: "daca/historico/devolucao",
	TIPO_TRANSACAO:
		"daca/{id}/filtro?tiposTransacao={historicoDaca}&tipoQuantidadeEstoqueDACA={tipoQuantidadeEstoqueDACA}",
	EDITAR_ENTRADA: "daca/historico/editEntrada",
	EDITAR_SAIDA: "daca/historico/editSaida",
	EDITAR_MOVIMENTACAO: "daca/historico/editMovimentacao",
	EDITAR_DEVOLUCAO: "daca/historico/editDevolucao",
	CANCELAR_TRANSACAO: "daca/historico/cancelarTransacao",
	FIND_HISTORICO_FILTRO: "daca/historico/filtro",
	FIND_ID_HISTORICO: "daca/historico/findById/{id}",
	FIND_HISTORICO_EDITAR: "daca/historico/findEditarById/{id}"
};

/*
	ROTAS MUNICIPIO
*/
export const MUNICIPIO = {
	FIND_ALL: "municipio",
	FIND_ALL_BY_CREPDEC: "municipio/crepdec/{crepdecId}"
};

/*
	ROTAS ESTOQUE
*/
export const ESTOQUE = {
	FIND_ALL: "estoque",
	FIND_MOVIMENTACAO: "estoque/movimentacao",
	FIND_ID: "estoque/findByDacaId/{id}",
	FIND_ORIGEM_DACA: "estoque/findOrigemByDacaId/{dacaId}/{estoqueOrigemId}",
	SAIDA: "estoque/saida",
	FIND_ALL_ATIVAS_MAPA: "ocorrencia/findAll/ativas/mapa",
	FIND_ALL_ATIVAS: "ocorrencia/findAll/ativas",
	FIND_DESTINO_EMPRESTIMO: "estoque/destinoEmprestimo/{id}",
	FIND_DESTINO_EMPRESTIMO_EDITAR:
		"estoque/destinoEmprestimoEdit/{id}/{idEmprestimo}"
};
export const PRESTACAO_CONTAS = {
	FIND_ALL_FILTRO: "prestacaoContas/filtro",
	FIND_ID: "prestacaoContas/findById/{id}",
	FIND_ID_OCORRENCIA: "prestacaoContas/findByOcorrenciaId/{id}",
	FIND_HISTORICO_ID: "prestacaoContas/findByHistoricoId/{id}",
	FINALIZAR: "prestacaoContas/finalizar/",
	COUNT: "prestacaoContas/count",
	OCORRENCIA_INFO_STATUS: "ocorrencia/infoStatus/{id}",
	STATUS: "prestacaoContas/status",
	LOCAL_PROCESSO: "prestacaoContas/localProcesso",
	FIND_ALL_FORMA: "prestacaoContas/forma"
};
